module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/qr-code-de2606072813e3a55e5f134077d24acf.png";